import { useEffect, lazy, Suspense } from "react";
import { Route, Routes, useLocation, Navigate } from "react-router-dom";
import { Fragment } from "react";
import Navbar from "./Navigation/Navbar";
import About from "./Routes/About/About";
import Contact from "./Routes/Contact/Contact";
import Blog from "./Routes/Blog/Blog";
import Home from "./Routes/Home/Home";
import Signup from "./Auth/Signup/Signup";
import Login from "./Auth/Login/Login";
import Businessdetails from "./Auth/BusinessDetails/businessdetails";
import SiteFooter from "./SiteFooter";
import ForgetPass from "./Auth/Forget/ForgetPass";
import ResetPassword from "./Auth/Reset/ResetPass";
import FaqComponent from "./Faq/FaqComponent";
import Sender from "./Routes/Ship/Sender";
import PackageReceiver from "./Routes/Ship/PackageRceiver";
import PackageCategory from "./Routes/Ship/PackageCategory";
import Summary from "./Routes/Ship/summary";
import Getquote from "./Routes/Getquote/Getquote";
import SingleBlog from "./Routes/Blog/BlogDetail";
import EmailVerificationForm from "./Auth/Token/EmailVerification";
import Onetimeverificationcode from "./Auth/Token/onetimeverificationcode";
import OtpRequest from "./Auth/Token/OtpRequest";
import SuscriberForm from "./Routes/Company_Bond/suscriberform";
import { AuthContext } from "./Context/AuthContext";
import { useContext } from "react";
import OverView from "./Support/SupportOverView/OverView";
import ScrollToTop from "./Footer/ScrollToTop";
import NotFound from "./Routes/NotFound/notfound";

import SupportDash from "./Support/SupportNav/SupportDash";
import SupportMessage from "./Support/PublicMessage/SupportMessage";
import TrackPackage from "./Support/TrackPackage/TrackPackage";
import AdminChat from "./Support/AdminChat/AdminChat";
import SupportSetting from "./Support/SupportSetting/SupportSetting";
import SupportChangePass from "./Support/SupportSetting/SupportPassword/SupportChangePass";
import Allcustomerconcern from "./Support/All_concern/allcustomerconcern";
import Concernsdetails from "./Support/Concern_details/concernsdetails";
import Openconcerns from "./Support/Open_concerns/openconcerns";

import Superadminoverview from "./super_admin/super_admin-overview/Superadminoverview";
import Superadmindispatches from "./super_admin/super_admin_dispatches/Superadmindispatches";
import Superadminpackagedeatails from "./super_admin/super_admin_packagedetails/Superadminpackagedeatails";
import SuperAdminDispatchDetails from "./super_admin/super_admin_dispatchdetails/super_admin_dispachdetails";
import Superadminlogistic from "./super_admin/super_admin_logistic/superadminlogistic";
import Superamdindriver from "./super_admin/super_admin_driver/super_amdin_driver";
import Superadminresgisterlogistics from "./super_admin/super_admin_register_logistics/superadminresgisterlogistics";
import Superadminregisterdriver from "./super_admin/super_admin_register_driver/Superadminregisterdriver";
import Superadminrider from "./super_admin/super_admin_rider/Superadminrider";
import Superadminregisterrider from "./super_admin/super_admin_register_rider/Superadminregisterrider";
import Superadminmrarketmanager from "./super_admin/super_admin_m_place/Superadminm-manager";
import Superregisstermarkeplace from "./super_admin/super_admin_register_market_manager/Superregisstermarkeplace";
import Superadminsupport from "./super_admin/super_admin_support/Superadminsupport";
import Supperadminregistersupport from "./super_admin/super_admin_register_ssupport/Supperadminregistersupport";
import Superadminblog from "./super_admin/super_admin_blog/Superadminblog";
import Superadmincreateblog from "./super_admin/super_admin_create_blogs/Superadmincreateblog";
import Superadminchat from "./super_admin/super_admin_chat/Superadminchat";
import Superadminbroadcast from "./super_admin/super_admin_brocasst/Superadminbroadcast";
import Superadminsetting from "./super_admin/super_admin-settings/Superadminsetting";
import Superadminchangepass from "./super_admin/super_admin_changepass/Superadminchangepass";
import SuperNavbar from "./super_admin/super_admin_navbar/Supernavabr";
import SuperadminToken from "./super_admin/Super_admin_token/superadmintoken";
import SuperadminCharterer from "./super_admin/super_admin_charterer/superadmincharterer";
import SuperAdminFreight from "./super_admin/super_admin_freight/superadminfreight";
import Createchartererofficer from "./super_admin/super_admin_create_charterer/createchartererofficer";
import Createfreightofficer from "./super_admin/super_admin_create_freight/createfreightofficer";
import Superadminviewallpackage from "./super_admin/super_admin_viewAll_package/superadminviewallpackage";
import Superadminshippingcost from "./super_admin/super_admin_shipping_cost/superadminshippingcost";
import Superadmincreateshipcost from "./super_admin/super_admin_create_cost/superadmincreateshipcost";
import Superadmingetquote from "./super_admin/supera_admin_getquote/superadmingetquote";
import Superadmincreateinvestor from "./super_admin/super_admin_create_investor/superadmincreateinvestor";
import Superadmininvestor from "./super_admin/super_admin_investors/superadmininvestor";
import Ontripdriver from "./super_admin/super_admin_ontrip-driver/ontripdriver";
import Localshippingcost from "./super_admin/super_admin_local_shipping_cost/localshippingcost";
import Createlocalshippingcost from "./super_admin/super_admin_create_local_shipping_cost/createlocalshippingcost";
import AllUsers from "./super_admin/super_admin_all_users/allusers";
import Superadminundeliveredpackages from "./super_admin/super_admin_undelivered_package/superadminundeliveredpackages";
import Superadminallbranchpackages from "./super_admin/super_admin_all_branch_packages/superadminallbranchpackages";
import Superadmingetquotelocalcost from "./super_admin/super_admin_getquote_localcost/superadmingetquotelocalcost";
import Superadminbusinessusers from "./super_admin/Super_admin_business_users/superadminbusinessusers";
import Superadminuserswallet from "./super_admin/Super_admin_users_wallet/superadminuserswallet";
import Superadmincreatorpackages from "./super_admin/Super_admin_creator_packages/superadmincreatorpackages";

import Charteringservice from "./Routes/Chartering/charteringservice";
import Carcharterservice from "./Routes/Chartering/AllCharter/carcharterservice";
import Jeepcharterservice from "./Routes/Chartering/AllCharter/jeepcharterservice";
import Siennacharterservice from "./Routes/Chartering/AllCharter/siennacharterservice";
import Buscharterservice from "./Routes/Chartering/AllCharter/buscharterservice";
import Executivecharter from "./Routes/Chartering/AllCharter/executivecharter";
import Charterdetail from "./Routes/Chartering/CharterDetails/charterdetail";
import Passengerdetails from "./Routes/Chartering/Passenger/passengerdetails";
import Charterdash from "./Routes/Chartering/CharterAdmin/CharterDash/charterdash";
import Charters from "./Routes/Chartering/CharterAdmin/Charter/charters";
import Vehicle from "./Routes/Chartering/CharterAdmin/Vehicle/vehicle";
import Setting from "./Routes/Chartering/CharterAdmin/Setting/setting";
import Addvehicle from "./Routes/Chartering/CharterAdmin/Vehicle/addvehicle";
import Vehicledetail from "./Routes/Chartering/CharterAdmin/Vehicle/VehicleDetail/vehicledetail";
import Charterpassword from "./Routes/Chartering/CharterAdmin/Setting/charterpassword";
import Startedcharter from "./Routes/Chartering/CharterAdmin/Charter/startedcharter";
import Completedcharter from "./Routes/Chartering/CharterAdmin/Charter/completedcharter";
import Bookrequest from "./Routes/Chartering/CharterAdmin/Charter/bookrequest";
import Order from "./Routes/Chartering/CharterAdmin/Charter/order";
import Overview from "./Routes/Chartering/CharterAdmin/Charter/overview";

import Truckselection from "./Routes/Freight/truckselection";
import Neworderfreight from "./Routes/Freight/Admin/Freight_Charter/neworderfreight";
import Completedfreight from "./Routes/Freight/Admin/Freight_Charter/completedfreight";
import Startedfreight from "./Routes/Freight/Admin/Freight_Charter/startedfreight";
import Freightdash from "./Routes/Freight/Admin/Freight_Dash/freightdash";
import Freightpassword from "./Routes/Freight/Admin/Setting/freightpassword";
import Freightsetting from "./Routes/Freight/Admin/Setting/freightsetting";
import Addtrucks from "./Routes/Freight/Admin/Truck_Freight/addtrucks";
import Freighttruck from "./Routes/Freight/Admin/Truck_Freight/freighttruck";
import Freightbookrequest from "./Routes/Freight/Admin/Freight_Charter/freightbookrequest";
import Adminorder from "./Routes/Freight/Admin/Freight_Charter/adminorder";
import Freightoverview from "./Routes/Freight/Admin/Freight_Charter/freightoverview";
import Truckdetail from "./Routes/Freight/Admin/Truck_Freight/TruckDetail/truckdetail";
import Selectedtruckdetails from "./Routes/Freight/SelectionDetails/selectedtruckdetails";
import Onrepairtruck from "./Routes/Freight/Admin/Freight_Charter/onrepairtruck";

import International from "./Routes/International/international";

import LogistcsNavbar from "./Logistics_manager/Logistics_manager_navbar/Logisticsnavbar";
import Logisticoverview from "./Logistics_manager/Logistic_overview/Logisticoverview";
import Logisticpackagedetails from "./Logistics_manager/Logistics-package-details/Logisticpackagedetails";
import Logisticsactivedispatch from "./Logistics_manager/Logistics_active_dispactch/Logisticsactivedispatch";
import Logisticsdriverrider from "./Logistics_manager/Logisstic_driver_rider/Logisticsdriverrider";
import Logisticcreatecategory from "./Logistics_manager/Logistics_create_category/Logisticcreatecategory";
import Logisticsender from "./Logistics_manager/Logisctisc_create_packages/Logisticsender";
import Logisticsreceiever from "./Logistics_manager/Logisctisc_create_packages/Logisticsreceiever";
import Logisticsitems from "./Logistics_manager/Logisctisc_create_packages/Logisticsitems";
import Logisticssummary from "./Logistics_manager/Logisctisc_create_packages/Logisticssummary";
import Logisticspackages from "./Logistics_manager/Logisticspackages/Logisticspackages";
import Logissticspickups from "./Logistics_manager/Logistics_pickups/Logissticspickups";
import Logisticspicupdetails from "./Logistics_manager/Logisticspickupdetails/Logisticspicupdetails";
import Logisticstrips from "./Logistics_manager/Logisticstrips/Logisticstrips";
import Logisticsinterstatetrips from "./Logistics_manager/Logisticsinterstates/Logisticsinterstatetrips";
import Logisticactivepkg from "./Logistics_manager/Logisticactivepkg/Logisticactivepkg";
import Logissticsacivedps from "./Logistics_manager/Logisticsacivedptc/Logissticsacivedps";
import Logisticsortcenter from "./Logistics_manager/Sorcenterarrival/Logisticsortcenter/Logisticsortcenter";
import Lgisticsettings from "./Logistics_manager/Logistic_settings/Logisticsettings";
import Logisticschnagepass from "./Logistics_manager/Logisticschangepass/Logisticschnagepass";
import Logisticsortassigned from "./Logistics_manager/Sorcenterarrival/Logisticsortassigned";
import LogisticBroadcastMsg from "./Logistics_manager/LogisticBroadcastMessage/LogisticBroadcastMsg";
import Packagereceipt from "./Logistics_manager/Logistics_package_receipt/packagereceipt";
import Logisticgetquote from "./Logistics_manager/Logistic_admin_get_quote/logisticgetquote";
import Logisticundeliveredpackages from "./Logistics_manager/Logistic_Undelivered_Packages/logisticundeliveredpackages";
import Logisticpackagecreation from "./Logistics_manager/Logisctisc_create_packages/logisticpackagecreation";
import Logisticbulkpackagecreation from "./Logistics_manager/Logisctisc_create_packages/logisticbulkpackagecreation";
import Logisticbulkupload from "./Logistics_manager/Logisctisc_create_packages/logisticbulkupload";
import Logisticinternationalpackagecreation from "./Logistics_manager/Logisctisc_create_packages/logisticinternationalpackagecreation";

import Drivernavbar from "./Driver_account/Driver_navbar/Drivernavbar";
import Driverhome from "./Driver_account/Driver_home/Driverhome";
import Driveraccepted from "./Driver_account/Driver_accpted/Driveraccepted";
import Driverassigndetails from "./Driver_account/Driver_assigned_details/Driverassigndetails";
import Driverprofile from "./Driver_account/Driver_profile/Driverprofile";
import Driverresetpass from "./Driver_account/Driver_pass/Driverresetpass";

import Ridernavbar from "./Rider_account/Rider_navbar/Ridernavbar";
import Riderhome from "./Rider_account/RIder_home/Riderhome";
import Rideraccepted from "./Rider_account/Rider_accpted/Rideraccepted";
import Riderassigneddetails from "./Rider_account/Rider_assigned_details/Riderassigneddetails";
import Riderprofile from "./Rider_account/Rider_profile/Riderprofile";
import Riderresetpass from "./Rider_account/Rider_reset_pass/Riderresetpass";
import Riderclosedassignment from "./Rider_account/Rider_closed_assignment/rider-closed-assignment";

import MerchantDashboardLayout from "./dashboard/merchant/MerchantDashboardLayout";
import MerchantOverviewPage from "./dashboard/merchant/pages/MerchantOverviewPage";
import MerchantProductsPage from "./dashboard/merchant/pages/MerchantProductsPage";
import MerchantAddProductPage from "./dashboard/merchant/pages/MerchantAddProductPage";
import MerchantProductDetailPage from "./dashboard/merchant/pages/MerchantProductDetailPage";
import MerchantOrdersPage from "./dashboard/merchant/pages/MerchantOrdersPage";
import MerchantOrderDetailPage from "./dashboard/merchant/pages/MerchantOrderDetailPage";
import MerchantAccountPage from "./dashboard/merchant/pages/MerchantAccountPage";
import MerchantPaymentsPage from "./dashboard/merchant/pages/MerchantPaymentsPage";
import MerchantInventoryPage from "./dashboard/merchant/pages/MerchantInventoryPage";
import MerchantAnalyticsPage from "./dashboard/merchant/pages/MerchantAnalyticsPage";
import MerchantReviewsPage from "./dashboard/merchant/pages/MerchantReviewsPage";
import MerchantStorePage from "./dashboard/merchant/pages/MerchantStorePage";
import MerchantNotificationsPage from "./dashboard/merchant/pages/MerchantNotificationsPage";
import AdminDashboardLayout from "./dashboard/admin/AdminDashboardLayout";
import AdminOverviewPage from "./dashboard/admin/pages/AdminOverviewPage";
import AdminProductsPage from "./dashboard/admin/pages/AdminProductsPage";
import AdminDealsPage from "./dashboard/admin/pages/AdminDealsPage";
import AdminMerchantsPage from "./dashboard/admin/pages/AdminMerchantsPage";
import AdminVerificationPage from "./dashboard/admin/pages/AdminVerificationPage";
import AdminMerchantDetailPage from "./dashboard/admin/pages/AdminMerchantDetailPage";
import AdminStoreProductsPage from "./dashboard/admin/pages/AdminStoreProductsPage";
import AdminOrdersPage from "./dashboard/admin/pages/AdminOrdersPage";
import AdminCustomersPage from "./dashboard/admin/pages/AdminCustomersPage";
import AdminCustomerDetailPage from "./dashboard/admin/pages/AdminCustomerDetailPage";
import AdminReviewsPage from "./dashboard/admin/pages/AdminReviewsPage";
import AdminAnalyticsPage from "./dashboard/admin/pages/AdminAnalyticsPage";
import AdminCategoriesPage from "./dashboard/admin/pages/AdminCategoriesPage";
import AdminBannersPage from "./dashboard/admin/pages/AdminBannersPage";
import AdminShippingPage from "./dashboard/admin/pages/AdminShippingPage";
import AdminMessagesPage from "./dashboard/admin/pages/AdminMessagesPage";
import AdminSettingsPage from "./dashboard/admin/pages/AdminSettingsPage";
import AdminPayoutsPage from "./dashboard/admin/pages/AdminPayoutsPage";
import AdminReturnsPage from "./dashboard/admin/pages/AdminReturnsPage";
import AdminFaqPage from "./dashboard/admin/pages/AdminFaqPage";
import AdminCommissionPage from "./dashboard/admin/pages/AdminCommissionPage";
import {
  LegacyRedirect,
  LegacyMerchantProductRedirect,
  LegacyAdminMerchantRedirect,
  LegacyAdminCustomerRedirect,
  LegacyStoreProductsRedirect,
  MERCHANT_LEGACY_ROUTES,
  ADMIN_LEGACY_ROUTES,
} from "./dashboard/config/legacyRedirects";
import {
  marketplaceLegacyRedirectRoutes,
  marketplaceHomeRoute,
  marketplaceRoutes,
} from "./Routes/Marketplace/MarketplaceAppRoutes";

import BusinessNavbar from "./Business_account/Navbar/business-navbar";
import Businessoverview from "./Business_account/Business_Overview/businessoverview";
import Businessusermanagement from "./Business_account/Business_user_Management/businessusermanagement";
import Businesswallet from "./Business_account/Business_wallet/businesswallet";
import Businessitemcategory from "./Business_account/Business_Item_Category/businessitemcategory";
import Businessshipment from "./Business_account/Business_shipment/businessshipment";
import Businesspackagedetails from "./Business_account/Business_package_details/businesspackagedetails";
import Businesspackageshipment from "./Business_account/Business_Ship_now/businesspackageshipment";
import Businesssenderdetails from "./Business_account/Business_national_delivery/businesssenderdetails";
import Businessreceiverdetails from "./Business_account/Business_national_delivery/businessreceiverdetails";
import Businesspackagecategory from "./Business_account/Business_national_delivery/businesspackagecategory";
import Businesssummarydetail from "./Business_account/Business_national_delivery/businesssummarydetail";
import PaymentVerification from "./Business_account/Business_verify/payment-verification";
import Businesspackagereceipt from "./Business_account/Business_Receipt/businesspackagereceipt";
import Businessgetquote from "./Business_account/Business_get_quote/businessgetquote";
import BusinessPendingOrder from "./Business_account/Business_pending_order/business_pending_order";
import InternationalPackageCreation from "./Business_account/Business_international/business_international_delivery";
import BusinessBulkUpload from "./Business_account/Business_bulk_upload/business_bulk_upload";
import BusinessBulkPackagesCreation from "./Business_account/Business_bulk_package_creation/business_bulk_packages_creation";
import MyConcerns from "./Business_account/Business_get_concerns/my-concerns";
import RaiseConcerns from "./Business_account/Business_raise_concerns/raise-concerns";
import Businessinterstatetrip from "./Business_account/Business_interstate_trip/businessinterstatetrip";

const AdminStoreProductDetailPage = lazy(() =>
  import("./dashboard/admin/pages/AdminStoreProductDetailPage")
);

const marketplaceRouteFragment = (
  <>
    {marketplaceLegacyRedirectRoutes}
    {marketplaceHomeRoute}
    {marketplaceRoutes}
  </>
);

function App() {
  const { isLoggedIn, user, token, businessRoles, authLoading } = useContext(AuthContext);
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  if (authLoading) {
    return (
      <Fragment>
        <Routes>
          {marketplaceRouteFragment}
        </Routes>
        <SiteFooter />
      </Fragment>
    );
  }

  if (!isLoggedIn) {
    return (
      <Fragment>
        <Routes>
          {marketplaceRouteFragment}
          <Route element={<Navbar />}>
            <Route index element={<Home />} />
            <Route path="/About" element={<About />} />
            <Route path="/Contact" element={<Contact />} />
            <Route path="/Blog" element={<Blog />} />
            <Route path="/FaqComponent" element={<FaqComponent />} />
            <Route path="/Sender" element={<Sender />} />
            <Route path="/SignUp" element={<Signup />} />
            <Route path="/Login" element={<Login />} />
            <Route path="/ForgetPass" element={<ForgetPass />} />
            <Route path="/ResetPassword" element={<ResetPassword />} />
            <Route path="/PackageReceiver" element={<PackageReceiver />} />
            <Route path="/PackageCategory" element={<PackageCategory />} />
            <Route path="/Getquote" element={<Getquote />} />
            <Route path="/summary" element={<Summary />} />
            <Route path="/blog/:blogId" element={<SingleBlog />} />
            <Route
              path="/EmailVerificationForm"
              element={<EmailVerificationForm />}
            />
            <Route path="/OtpRequest" element={<OtpRequest />} />
            <Route
              path="/onetimeverificationcode"
              element={<Onetimeverificationcode />}
            />
            <Route path="/charteringservice" element={<Charteringservice />} />
            <Route path="/carcharterservice" element={<Carcharterservice />} />
            <Route
              path="/jeepcharterservice"
              element={<Jeepcharterservice />}
            />
            <Route
              path="/siennacharterservice"
              element={<Siennacharterservice />}
            />
            <Route path="/buscharterservice" element={<Buscharterservice />} />
            <Route path="/executivecharter" element={<Executivecharter />} />
            <Route path="/car-details/:id" element={<Charterdetail />} />
            <Route path="/passengerdetails" element={<Passengerdetails />} />
            <Route path="/truckselection" element={<Truckselection />} />
            <Route path="/international" element={<International />} />
            <Route path="/suscriberform" element={<SuscriberForm />} />
            <Route
              path="/selectedtruck/:id"
              element={<Selectedtruckdetails />}
            />
            <Route path="/businessdetails" element={<Businessdetails />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
        <SiteFooter />
        <ScrollToTop />
      </Fragment>
    );
  }

  if (token && user?.role === "support") {
    return (
      <Routes>
        <Route path="/" element={<SupportDash />}>
          <Route index element={<OverView />} />
          <Route path="/SupportMessage" element={<SupportMessage />} />
          <Route path="/AdminChat" element={<AdminChat />} />
          <Route path="/TrackPackage" element={<TrackPackage />} />
          <Route path="/SupportSetting" element={<SupportSetting />} />
          <Route path="/SupportChangePass" element={<SupportChangePass />} />
          <Route path="/allcustomerconcern" element={<Allcustomerconcern />} />
          <Route path="/openconcerns" element={<Openconcerns />} />
          <Route
            path="/concernsdetails/:concernId"
            element={<Concernsdetails />}
          />
        </Route>
      </Routes>
    );
  }

  if (token && user?.role === "customer") {
    return (
      <Fragment>
        <Routes>
          {marketplaceRouteFragment}
        </Routes>
        <SiteFooter />
      </Fragment>
    );
  }

  if (token && user?.role === "superadmin") {
    return (
      <Routes>
        <Route path="/" element={<SuperNavbar />}>
          <Route index element={<Superadminoverview />} />
          <Route
            path="/Superadmindispatches"
            element={<Superadmindispatches />}
          />
          <Route path="/allusers" element={<AllUsers />} />
          <Route path="/packages/:id" element={<Superadminpackagedeatails />} />
          <Route
            path="/dispatchdetails/:id"
            element={<SuperAdminDispatchDetails />}
          />
          <Route path="/Superadminlogistic" element={<Superadminlogistic />} />
          <Route
            path="/Superadminresgisterlogistics"
            element={<Superadminresgisterlogistics />}
          />
          <Route path="/Superamdindriver" element={<Superamdindriver />} />
          <Route
            path="/Superadminregisterdriver"
            element={<Superadminregisterdriver />}
          />
          <Route path="/Superadminrider" element={<Superadminrider />} />
          <Route
            path="/Superadminregisterrider"
            element={<Superadminregisterrider />}
          />
          <Route
            path="/Superadminmrarketmanager"
            element={<Superadminmrarketmanager />}
          />
          <Route
            path="/Superregisstermarkeplace"
            element={<Superregisstermarkeplace />}
          />
          <Route path="/Superadminsupport" element={<Superadminsupport />} />
          <Route
            path="/Supperadminregistersupport"
            element={<Supperadminregistersupport />}
          />
          <Route path="/Superadminblog" element={<Superadminblog />} />
          <Route
            path="/Superadmincreateblog"
            element={<Superadmincreateblog />}
          />
          <Route path="/Superadminchat" element={<Superadminchat />} />
          <Route
            path="/Superadminbroadcast"
            element={<Superadminbroadcast />}
          />
          <Route path="/Superadminsetting" element={<Superadminsetting />} />
          <Route
            path="/Superadminchangepass"
            element={<Superadminchangepass />}
          />
          <Route path="/superadmintoken" element={<SuperadminToken />} />
          <Route
            path="/superadmincharterer"
            element={<SuperadminCharterer />}
          />
          <Route path="/superadminfreight" element={<SuperAdminFreight />} />
          <Route
            path="/createchartererofficer"
            element={<Createchartererofficer />}
          />
          <Route
            path="/createfreightofficer"
            element={<Createfreightofficer />}
          />
          <Route
            path="/superadminviewallpackage"
            element={<Superadminviewallpackage />}
          />
          <Route
            path="/superadminshippingcost"
            element={<Superadminshippingcost />}
          />
          <Route path="/superadmingetquote" element={<Superadmingetquote />} />
          <Route
            path="/superadmincreateshipcost"
            element={<Superadmincreateshipcost />}
          />
          <Route path="/superadmininvestor" element={<Superadmininvestor />} />
          <Route
            path="/superadmincreateinvestor"
            element={<Superadmincreateinvestor />}
          />
          <Route path="/ontripdriver" element={<Ontripdriver />} />
          <Route path="/localshippingcost" element={<Localshippingcost />} />
          <Route
            path="/createlocalshippingcost"
            element={<Createlocalshippingcost />}
          />
          <Route
            path="/superadminundeliveredpackages"
            element={<Superadminundeliveredpackages />}
          />
          <Route
            path="/superadminallbranchpackages"
            element={<Superadminallbranchpackages />}
          />
          <Route
            path="/superadmingetquotelocalcost"
            element={<Superadmingetquotelocalcost />}
          />
          <Route
            path="/superadminbusinessusers"
            element={<Superadminbusinessusers />}
          />
          <Route
            path="/superadminuserswallet"
            element={<Superadminuserswallet />}
          />
          <Route
            path="/superadmincreatorpackages"
            element={<Superadmincreatorpackages />}
          />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    );
  } else if (token && user?.role === "logisticsmanager") {
    return (
      <Routes>
        <Route path="/" element={<LogistcsNavbar />}>
          <Route index element={<Logisticoverview />} />
          <Route path="/details/:id" element={<Logisticpackagedetails />} />
          <Route
            path="/Logisticsactivedispatch"
            element={<Logisticsactivedispatch />}
          />
          <Route
            path="/Logisticsdriverrider"
            element={<Logisticsdriverrider />}
          />
          <Route
            path="/Logisticcreatecategory"
            element={<Logisticcreatecategory />}
          />
          <Route path="/Logisticsender" element={<Logisticsender />} />
          <Route path="/Logisticsreceiever" element={<Logisticsreceiever />} />
          <Route path="/Logisticsitems" element={<Logisticsitems />} />
          <Route path="/Logisticssummary" element={<Logisticssummary />} />
          <Route path="/Logisticspackages" element={<Logisticspackages />} />
          <Route path="/Logissticspickups" element={<Logissticspickups />} />
          <Route path="/predetails/:id" element={<Logisticspicupdetails />} />
          <Route path="/Logisticstrips" element={<Logisticstrips />} />
          <Route path="/logisticbulkupload" element={<Logisticbulkupload />} />
          <Route
            path="/logisticbulkpackagecreation"
            element={<Logisticbulkpackagecreation />}
          />
          <Route
            path="/logisticinternationalpackagecreation"
            element={<Logisticinternationalpackagecreation />}
          />
          <Route
            path="/logisticpackagecreation"
            element={<Logisticpackagecreation />}
          />
          <Route
            path="/Logisticsinterstatetrips"
            element={<Logisticsinterstatetrips />}
          />
          <Route path="/Logisticactivepkg" element={<Logisticactivepkg />} />
          <Route path="/Logissticsacivedps" element={<Logissticsacivedps />} />
          <Route path="/Logisticsortcenter" element={<Logisticsortcenter />} />
          <Route path="/Lgisticsettings" element={<Lgisticsettings />} />
          <Route
            path="/Logisticschnagepass"
            element={<Logisticschnagepass />}
          />
          <Route
            path="/Logisticsortassigned"
            element={<Logisticsortassigned />}
          />
          <Route
            path="/LogisticBroadcastMsg"
            element={<LogisticBroadcastMsg />}
          />
          <Route path="/packagereceipt" element={<Packagereceipt />} />
          <Route path="/logisticgetquote" element={<Logisticgetquote />} />
          <Route
            path="/logisticundeliveredpackages"
            element={<Logisticundeliveredpackages />}
          />
        </Route>
      </Routes>
    );
  } else if (token && user?.role === "driver") {
    return (
      <Routes>
        <Route path="/" element={<Drivernavbar />}>
          <Route index element={<Driverhome />} />
          <Route path="/Driveraccepted" element={<Driveraccepted />} />
          <Route
            path="/details/:assignmentId"
            element={<Driverassigndetails />}
          />
          <Route
            path="/Driveraccepted/details/:assignmentId"
            element={<Driverassigndetails />}
          />
          <Route path="/Driverprofile" element={<Driverprofile />} />
          <Route path="/Driverresetpass" element={<Driverresetpass />} />
        </Route>
      </Routes>
    );
  } else if (token && user?.role === "rider") {
    return (
      <Routes>
        <Route path="/" element={<Ridernavbar />}>
          <Route index element={<Riderhome />} />
          <Route path="/Rideraccepted" element={<Rideraccepted />} />
          <Route
            path="/details/:assignmentId"
            element={<Riderassigneddetails />}
          />
          <Route
            path="/Rideraccepted/details/:assignmentId"
            element={<Riderassigneddetails />}
          />
          <Route path="/Riderprofile" element={<Riderprofile />} />
          <Route path="/Riderresetpass" element={<Riderresetpass />} />
          <Route
            path="/Riderclosedassignment"
            element={<Riderclosedassignment />}
          />
        </Route>
      </Routes>
    );
  } else if (token && user?.role === "marketplacemanager") {
    return (
      <Routes>
        {marketplaceRouteFragment}
        {ADMIN_LEGACY_ROUTES.map(({ path, to }) => (
          <Route key={path} path={path} caseSensitive element={<LegacyRedirect to={to} />} />
        ))}
        <Route path="/user/:id" element={<LegacyAdminMerchantRedirect />} />
        <Route path="/markeplacecustomer/:id" element={<LegacyAdminCustomerRedirect />} />
        <Route path="/storeproducts/:merchantId" element={<LegacyStoreProductsRedirect />} />
        <Route path="/admin" element={<AdminDashboardLayout />}>
          <Route index element={<AdminOverviewPage />} />
          <Route path="products" element={<AdminProductsPage />} />
          <Route path="deals" element={<AdminDealsPage />} />
          <Route path="merchants" element={<AdminMerchantsPage />} />
          <Route path="verification" element={<AdminVerificationPage />} />
          <Route path="merchants/:id" element={<AdminMerchantDetailPage />} />
          <Route path="merchants/:merchantId/products/:productId" element={
            <Suspense fallback={<div className="dashboard-card" style={{ padding: 24 }}>Loading product…</div>}>
              <AdminStoreProductDetailPage />
            </Suspense>
          } />
          <Route path="merchants/:merchantId/products" element={<AdminStoreProductsPage />} />
          <Route path="orders" element={<AdminOrdersPage />} />
          <Route path="payouts" element={<AdminPayoutsPage />} />
          <Route path="returns" element={<AdminReturnsPage />} />
          <Route path="commission" element={<AdminCommissionPage />} />
          <Route path="faq" element={<AdminFaqPage />} />
          <Route path="customers" element={<AdminCustomersPage />} />
          <Route path="customers/:id" element={<AdminCustomerDetailPage />} />
          <Route path="reviews" element={<AdminReviewsPage />} />
          <Route path="analytics" element={<AdminAnalyticsPage />} />
          <Route path="categories" element={<AdminCategoriesPage />} />
          <Route path="banners" element={<AdminBannersPage />} />
          <Route path="shipping" element={<AdminShippingPage />} />
          <Route path="messages" element={<AdminMessagesPage />} />
          <Route path="settings" element={<AdminSettingsPage />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route path="/" element={<Navigate to="/admin" replace />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    );
  } else if (token && user?.role === "merchant") {
    return (
      <Routes>
        {marketplaceRouteFragment}
        {MERCHANT_LEGACY_ROUTES.map(({ path, to }) => (
          <Route key={path} path={path} caseSensitive element={<LegacyRedirect to={to} />} />
        ))}
        <Route path="/product/:slug" element={<LegacyMerchantProductRedirect />} />
        <Route path="/merchant" element={<MerchantDashboardLayout />}>
          <Route index element={<MerchantOverviewPage />} />
          <Route path="products" element={<MerchantProductsPage />} />
          <Route path="products/new" element={<MerchantAddProductPage />} />
          <Route path="products/:slug" element={<MerchantProductDetailPage />} />
          <Route path="orders" element={<MerchantOrdersPage />} />
          <Route path="orders/:orderId" element={<MerchantOrderDetailPage />} />
          <Route path="payments" element={<MerchantPaymentsPage />} />
          <Route path="inventory" element={<MerchantInventoryPage />} />
          <Route path="analytics" element={<MerchantAnalyticsPage />} />
          <Route path="reviews" element={<MerchantReviewsPage />} />
          <Route path="store" element={<MerchantStorePage />} />
          <Route path="notifications" element={<MerchantNotificationsPage />} />
          <Route path="account" element={<MerchantAccountPage />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route path="/" element={<Navigate to="/merchant" replace />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    );
  } else if (token && user?.role === "charterer") {
    return (
      <Routes>
        <Route path="/" element={<Charterdash />}>
          <Route index element={<Overview />} />
          <Route path="/vehicle" element={<Vehicle />} />
          <Route path="/addvehicle" element={<Addvehicle />} />
          <Route path="/setting" element={<Setting />} />
          <Route path="/charterpassword" element={<Charterpassword />} />
          <Route path="/completedcharter" element={<Completedcharter />} />
          <Route path="/startedcharter" element={<Startedcharter />} />
          <Route path="/bookrequest" element={<Bookrequest />} />
          <Route path="/order" element={<Order />} />
          <Route path="/charter" element={<Charters />} />
          <Route path="/vehicle/:id" element={<Vehicledetail />} />
        </Route>
      </Routes>
    );
  } else if (token && user?.role === "freightmanager") {
    return (
      <Routes>
        <Route path="/" element={<Freightdash />}>
          <Route index element={<Freightoverview />} />
          <Route path="/startedfreight" element={<Startedfreight />} />
          <Route path="/completedfreight" element={<Completedfreight />} />
          <Route path="/freightpassword" element={<Freightpassword />} />
          <Route path="/freightsetting" element={<Freightsetting />} />
          <Route path="/addtrucks" element={<Addtrucks />} />
          <Route path="/freighttruck" element={<Freighttruck />} />
          <Route path="/neworderfreight" element={<Neworderfreight />} />
          <Route path="/adminorder" element={<Adminorder />} />
          <Route path="/freightbookrequest" element={<Freightbookrequest />} />
          <Route path="/onrepairtruck" element={<Onrepairtruck />} />
          <Route path="/truck/:id" element={<Truckdetail />} />
        </Route>
      </Routes>
    );
  } else if (token) {
    const isBusinessIndustry = Array.isArray(businessRoles?.businesses)
      ? businessRoles.businesses.some(
          (business) => business.industry === user?.role
        )
      : false;

    if (isBusinessIndustry) {
      return (
        <Routes>
          <Route path="/" element={<BusinessNavbar />}>
            <Route index element={<Businessoverview />} />
            <Route
              path="/businessusermanagement"
              element={<Businessusermanagement />}
            />
            <Route
              path="/businessitemcategory"
              element={<Businessitemcategory />}
            />
            <Route path="/businessshipment" element={<Businessshipment />} />
            <Route
              path="/businesspackageshipment"
              element={<Businesspackageshipment />}
            />
            <Route
              path="/businesssenderdetails"
              element={<Businesssenderdetails />}
            />
            <Route
              path="/businessreceiverdetails"
              element={<Businessreceiverdetails />}
            />
            <Route
              path="/businesspackagecategory"
              element={<Businesspackagecategory />}
            />
            <Route
              path="/businesssummarydetail"
              element={<Businesssummarydetail />}
            />
            <Route path="/details/:id" element={<Businesspackagedetails />} />
            <Route path="/businesswallet" element={<Businesswallet />} />
            <Route
              path="/businesspackagereceipt"
              element={<Businesspackagereceipt />}
            />
            <Route path="/businessgetquote" element={<Businessgetquote />} />
            <Route
              path="/payment-verification"
              element={<PaymentVerification />}
            />
            <Route
              path="/business_pending_order"
              element={<BusinessPendingOrder />}
            />
            <Route
              path="/business_international_delivery"
              element={<InternationalPackageCreation />}
            />
            <Route
              path="/business_bulk_upload"
              element={<BusinessBulkUpload />}
            />
            <Route
              path="/business_bulk_packages_creation"
              element={<BusinessBulkPackagesCreation />}
            />
            <Route path="/my-concerns" element={<MyConcerns />} />
            <Route path="/raise-concerns" element={<RaiseConcerns />} />
            <Route
              path="/businessinterstatetrip"
              element={<Businessinterstatetrip />}
            />
          </Route>
        </Routes>
      );
    }
  }
}

export default App;
